module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "time-picker"
  }, [(_vm.isDuration) ? _c('span', {
    staticClass: "inputHolder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timestamp),
      expression: "timestamp"
    }],
    staticClass: "display-time full",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.timestamp)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown.apply(null, arguments)
      },
      "blur": _vm.update,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateAndClose.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timestamp = $event.target.value
      }
    }
  })]) : _c('span', {
    staticClass: "inputHolder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timestamp),
      expression: "timestamp"
    }],
    staticClass: "display-time full",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.timestamp)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown.apply(null, arguments)
      },
      "blur": _vm.update,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateAndClose.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timestamp = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "dropdown",
    class: {
      showOnTop: _vm.showOnTop
    }
  }, [_c('div', {
    staticClass: "select-list"
  }, [_c('ul', {
    staticClass: "hours"
  }, [_c('li', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.hourHint))]), _vm._v(" "), _vm._l((_vm.availableHours), function(h) {
    return _c('li', {
      class: {
        active: _vm.hours === h
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changedHours(h)
        }
      }
    }, [_vm._v(_vm._s(h))])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "minutes"
  }, [_c('li', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.minuteHint))]), _vm._v(" "), _vm._l((_vm.availableMinutes), function(m) {
    return _c('li', {
      class: {
        active: _vm.minutes === m
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changedMinutes(m)
        }
      }
    }, [_vm._v(_vm._s(m))])
  })], 2)])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6b70bf82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b70bf82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Timepicker.vue
// module id = 1341
// module chunks = 0